import { Editor, Node, Path, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { crossesLayoutItem, findCaretBlock } from '../../helpers/utilities/layout/boundary';
import { deleteAcrossItems, isCrossingSelection } from '../../helpers/utilities/layout/cross-delete';

import { hasTarget } from './paste';

const types = serializer.types;

function isLayoutAfter(editor, path) {

  const nextPath = Path.next(path);

  return Node.has(editor, nextPath) === true && Node.get(editor, nextPath).type === types.LAYOUT;

}

// Backspace at the start of a block never pulls its text into a layout, out of one, or into the
// previous item of a row. The paragraph plugin handles empty paragraphs before this runs.
function shouldKeepBackward(editor) {

  const entry = findCaretBlock(editor);

  if (entry === null || Editor.isStart(editor, editor.selection.anchor, entry[1]) === false) {
    return false;
  }

  const before = Editor.before(editor, entry[1]);

  return typeof before !== 'undefined' && crossesLayoutItem(editor, entry[1], before.path) === true;

}

// Delete is the mirror image, except that an empty block right before a layout is removed.
function deleteForwardAcrossItem(editor, deleteForward, unit) {

  const entry = findCaretBlock(editor);

  if (entry === null || Editor.isEnd(editor, editor.selection.anchor, entry[1]) === false) {
    return deleteForward(unit);
  }

  const after = Editor.after(editor, entry[1]);

  if (typeof after === 'undefined' || crossesLayoutItem(editor, entry[1], after.path) === false) {
    return deleteForward(unit);
  }

  if (Editor.isEmpty(editor, entry[0]) === true && isLayoutAfter(editor, entry[1]) === true) {
    Transforms.removeNodes(editor, { at: entry[1] });
    Transforms.select(editor, Editor.start(editor, entry[1]));
  }

}

export function withLayoutDelete(editor) {

  const deleteBackward = editor.deleteBackward;
  const deleteForward = editor.deleteForward;
  const deleteFragment = editor.deleteFragment;
  const insertText = editor.insertText;

  editor.deleteBackward = function deleteBackwardInLayout(unit) {

    if (shouldKeepBackward(editor) === true) {
      return;
    }

    deleteBackward(unit);

  };

  editor.deleteForward = function deleteForwardInLayout(unit) {
    deleteForwardAcrossItem(editor, deleteForward, unit);
  };

  editor.deleteFragment = function deleteFragmentInLayout(options) {

    if (isCrossingSelection(editor) === true) {
      deleteAcrossItems(editor);
      return;
    }

    deleteFragment(options);

  };

  editor.insertText = function insertTextInLayout(text, options) {

    if (hasTarget(options) === false && isCrossingSelection(editor) === true) {
      deleteAcrossItems(editor);
    }

    insertText(text, options);

  };

  return editor;

}
